import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import View from './view';
import * as Actions from './actions';

import * as StaffSelectors from 'shared_redux/selectors/view/staff';
import * as OrganizationSelectors from 'shared_redux/selectors/models/organizations';

const mapStateToProps = (state) => {
    console.log('State.staff:', state.staff);

    const currentOrganization = OrganizationSelectors.getCurrentOrganization(state);
    const staffMembers = StaffSelectors.getFilteredStaffMembers(state);
    const allStaffMembers = StaffSelectors.getStaffMembers(state);
    const pendingInvites = StaffSelectors.getPendingInvites(state);
    const loading = StaffSelectors.getStaffLoading(state);
    const searchTerm = StaffSelectors.getStaffSearchTerm(state);
    const error = StaffSelectors.getStaffError(state);
    const isUploadingLogo = StaffSelectors.getIsUploadingLogo(state);
    const isUploadingPhoto = StaffSelectors.getIsUploadingPhoto(state);

    return {
        currentOrganization,
        staffMembers,
        allStaffMembers,
        pendingInvites,
        loading,
        searchTerm,
        error,
        isUploadingLogo,
        isUploadingPhoto,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        fetchOrganizationRoles: Actions.fetchOrganizationRoles,
        updateStaffSearch: Actions.updateStaffSearch,
        assignRole: Actions.assignRole,
        removeRole: Actions.removeRole,
        inviteStaff: Actions.inviteStaff,
        fetchPendingInvites: Actions.fetchPendingInvites,
        cancelInvite: Actions.cancelInvite,
        updateOrganizationName: Actions.updateOrganizationName,
        uploadOrganizationLogo: Actions.uploadOrganizationLogo,
        uploadStaffPhoto: Actions.uploadStaffPhoto,
        clearStaffError: Actions.clearStaffError,
    }, dispatch);
};

const Container = connect(
    mapStateToProps,
    mapDispatchToProps
)(View);

export default Container;